import React, {Component,PureComponent} from 'react';
import {Field, reduxForm, FieldArray} from 'redux-form'
import {Row, Form, Divider} from 'antd';

import {RTLCol,RTLButton} from '../RTLKit';


/* ------ Field -------- */
import TextField from '../formFields/TextField';
import SelectField from '../formFields/SelectField';
import UploadField from '../formFields/UploadField';


/* ------ Validate / Warn  -------- */
import ValidateForm from './parts/addValidate';
import WarnForm from './parts/addWarn';
import jwtDecode from "jwt-decode";
import Loading from "../loading/loading";

class AddEditForm extends Component {
    constructor(props) {
        super(props);

        //---- Detect Add or Edit module
        this.state = {
            cities:[],
            formLayout: 'horizontal',
            role:this.props.userValue ? this.props.userValue.rl : null,
        };

        this.props.getUserInfo(this.props.match.params.userId);

    }

    onFormSubmit(value) {
        this.props.handleSubmit(value);
    }

    componentWillMount() {
        this.props.getUserList();
        if(this.props.match.params.userId) {
            let userId = this.props.match.params.userId;
            this.props.getTechnicianInfo(userId)
        }
    }

    render() {
        var _self = this;
        const {formLayout} = this.state
        let type = []
        if(this.props.userInfo) {
            var userName = this.props.userInfo.name + ' ' + this.props.userInfo.family;
            if(this.props.userInfo.role === 'TECHNICIAN')
                type = [
                    {label:'تراکنش اصلاحی',value:'TRX_CORRECTIVE',i:1}
                ]
            else
                type = [
                    {label:'تراکنش اصلاحی',value:'TRX_CORRECTIVE',i:1},
                    {label:'اعتبار هدیه',value:'TRX_GIFT_CREDIT',i:2}
                ]
        }

        return (
            <Form layout={formLayout} mode={this.state.mode} onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                <Row>
                    <Divider orientation="left">{this.state.mode == 'edit' ? "ویرایش" : "ایجاد"} تراکنش {userName ? 'برای '+userName : null}</Divider>
                </Row>
                {this.state.mode == 'edit' ?
                    <Loading list={this.props.initialValues} />
                : null}
                <Row type="flex" justify="start" align="middle">
                    <RTLCol md={18} sm={24} type="flex" justify="start" align="middle" >
                        <Row gutter={16}>

                            <Field
                                name="description"
                                component={TextField}
                                type="text"
                                label="توضیحات"
                                placeholder="توضیحات"
                            />
                            <Field
                                name="amount"
                                component={TextField}
                                type="number"
                                label="مبلغ(ریال)"
                                placeholder="مبلغ"
                                style={{textAlign:'right',direction:'ltr'}}
                            />
                            <Field
                                name="trx_type"
                                component={SelectField}
                                label="نوع تراکنش"
                                placeholder="نوع تراکنش"
                                list={type}
                            />

                        </Row>
                        <Row>
                            <RTLButton loading={this.props.common.isProgressing} type="primary"  shape="round" htmlType="submit" className="login-form-button">
                                {this.state.mode == 'edit' ? "ویرایش" : "ایجاد"}
                            </RTLButton>
                            <RTLButton href="#/user/list" className="backBtn" type="default" shape="round">
                                بازگشت
                            </RTLButton>
                        </Row>
                    </RTLCol>
                </Row>
            </Form>

        );
    }

}

export default AddEditForm = reduxForm({
    form: 'addTransaction',        // <--- a unique name for the form
    validate: ValidateForm, // <--- validation function given to redux-form
    warn: WarnForm
})(AddEditForm)
